import { useRef } from 'react'

import { X } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { InputGroup, InputGroupAddon, InputGroupButton } from '@fortem-monorepo/react-ui'

export interface KnockDownInputLevelFormFieldProps {}

export const KnockDownInputLevelFormField: React.FC<KnockDownInputLevelFormFieldProps> = ({}) => {
  const { control, register, setValue } = useFormContext<{
    knockdown_input_level: number
  }>()

  const ref = useRef<HTMLInputElement>(null)

  return (
    <FormField
      name="knockdown_input_level"
      control={control}
      render={({ field: { value, ref: _ref } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Knock Down & In Put Level</FormLabel>
              <FormError />
            </div>
            <InputGroup>
              <ControlledNumberInput
                className={
                  'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent'
                }
                {...register('knockdown_input_level')}
                ref={ref}
              />
              <InputGroupAddon>
                <InputGroupButton
                  onClick={() => {
                    setValue('knockdown_input_level', null as unknown as number, {
                      shouldValidate: true,
                    })
                    ref.current?.focus()
                  }}
                  disabled={value === null}
                >
                  <X />
                </InputGroupButton>
              </InputGroupAddon>
            </InputGroup>
          </FormItem>
        )
      }}
    />
  )
}
